/**
 * 付款管理
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { message } from 'antd';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/paymanage/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableAction as tac, RoleType } from '../../types';
import { TableActionType as ta } from '@/util/enum';
import PayModal from '../modal/PayModal';

class Main extends React.Component {

    state = {
        tel: '',
        receiver: '',
        state: {},
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        selectedKeys: [],
        openModeParam: {},
        currentOpenMode: ''
    }

    showAudit = false

    componentDidMount() {
        this.props.getStateList({ enumName: 'PaymentApplicationStatusEnum' });

        // http('/request?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.isOpenUnionWallet').then(res => {
        //     if (res.errCode === 0) {
        //         this.showAudit = res.result;
        //     }
        // })
    }

    // 查询
    _searchHandle = (useCache) => {
        const { tel, receiver, state, startTime, endTime, pageNum, pageSize } = this.state;
        this.searchCache = {
            phone: tel,
            payeeName: receiver,
            status: state.code,
            startTime,
            endTime,
            paymentApplicationType: this.props.curTabID,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ tel: '', receiver: '', state: {}, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 生成报表
    _newHandle = () => {
        if (this.state.selectedKeys.length > 0) {
            http('/?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.exportPaymentApplication', { ids: this.state.selectedKeys }, 'POST').then((res) => {
                if (res.errCode === 0) {
                    message.success('生成成功');
                }
            });
        } else {
            message.warn('请选择一条记录');
        }
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        const { history, curTabID } = this.props;
        switch (type) {
            case ta.detail:
                history.push({ pathname: `/home/finance/paymanage/${ta.detail}/${key}/${curTabID}` });
                break;
            case tac.first:
                history.push({ pathname: `/home/finance/paymanage/${tac.first}/${key}/${curTabID}` });
                break;
            case tac.last:
                history.push({ pathname: `/home/finance/paymanage/${tac.last}/${key}/${curTabID}` });
                break;
            case tac.pay:
                this.setState({ currentOpenMode: tac.pay, openModeParam: item });
                break;
            case ta.batch:
                this.setState({ selectedKeys: key });
                break;
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case tac.pay:
                return <PayModal title='付款' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    render() {
        const { tel, receiver, state, startTime, endTime } = this.state;
        let { curTabID, tableSource, stateList } = this.props;

        let showAudit = curTabID === RoleType.rider ? this.showAudit : true;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='手机号'
                                placeholder='请输入'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: '150px' }}
                                label='收款方'
                                placeholder='请输入'
                                value={receiver}
                                bindThis={this}
                                bindName='receiver'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='状态'
                                placeholder='请选择'
                                renderData={stateList}
                                dataIndex='value'
                                keyIndex='code'
                                value={state.value}
                                bindThis={this}
                                bindName='state'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='所得时间'
                                datePickerStyle={{ width: 200 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 200 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    {/* <div className={styles.row2}>
                        <XOKButton
                            style={{ width: '120px' }}
                            label='生成报表'
                            onClick={this._newHandle}
                        />
                    </div> */}
                    <TableList showAudit={showAudit} renderData={tableSource} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,

    getStateList: PropTypes.func,
    stateList: PropTypes.array
};
const mapStateToProps = (state) => ({
    stateList: state.paymanage.stateList,
    tableSource: state.paymanage.tableSource,
});

export default connect(mapStateToProps, { ...model.actions })(Main);